import { makeAutoObservable } from 'mobx';

class EmployeeStore {
  points: string[];

  constructor(points = []) {
    this.points = points;
    makeAutoObservable(this);
  }

  getCompanyInfo() {
    return `Employee of points: ${this.points.join(', ')}`;
  }
}

export const employeeStore = new EmployeeStore();
